import React from 'react';

// FormGroup custom (from scratch) — remplace le FormGroup de reactstrap.
// Comportement par défaut conservé : `mb-2` quand aucune classe n'est fournie.
// Supporte aussi les variantes reactstrap utilisées dans l'app :
// `check` / `switch` (form-check / form-switch), `row`, `inline`, `floating`.
const FormGroup = ({
  children,
  className,
  row,
  check,
  inline,
  floating,
  disabled,
  noMargin,
  switch: switchProp,
  tag: Tag = 'div',
  ...restProps
}) => {
  const formCheck = check || switchProp;

  let classes;
  if (formCheck) {
    classes = [
      'form-check',
      switchProp && 'form-switch',
      inline && 'form-check-inline',
      disabled && 'disabled',
      floating && 'form-floating',
      className,
    ]
      .filter(Boolean)
      .join(' ');
  } else {
    classes = [row && 'row', floating && 'form-floating', className || (noMargin ? null : 'mb-2')]
      .filter(Boolean)
      .join(' ');
  }

  return (
    <Tag className={classes} {...restProps}>
      {children}
    </Tag>
  );
};

export default FormGroup;
